import { css } from 'styled-components';
import { fonts } from '../../../style-utilities/variables';
export default css`
  h1 {
    font-size: 36px;
    margin-bottom: 0.2em;
    font-family: ${fonts.primary};
  }
`;
